/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Box, Modal, Button, Grid, Tooltip, Divider } from '@mui/material';
import $ from 'jquery';
import { get, map } from 'lodash';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import CFTable from './cf-table';
import CFProps from './cf-props';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { isObjectEmpty } from '../../shared/helper';
import { getBorderColor } from '../../shared/utils';
import './cf.scss';

const RoInput = (props) => {
  const { visibleCF, handleCloseCF, dbTransactionDetails, unitopDetails, disabledStripperAndExplorerTab, translateObject, setokbuttonFormAutoSave } = props;
  const [cfDetails, setCfDetails] = useState(map(get(dbTransactionDetails, 'cf_dict', {}), (val) => val));
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [selectedRow, setSelectedRow] = useState({});
  const [disableOkbutton, setDisableOkButton] = useState(true);
  const [properties, setProperties] = useState({
    flowPerTie: 0,
    flow: 0,
    numberOfFilters: 0,
    filterDP: 0,
    actualFlow: 0
  });
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);

  const handleClose_CF = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleCloseCF();
  };

  const handleCloseCFModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Do you want to close the CF input page?'),
        onYes: () => handleClose_CF(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseCF();
    };
  };

  useEffect(() => {
    const {users_dict} = dbTransactionDetails;
    const curr_user_email = sessionStorage.getItem('user_email');

    const isCfAdmin = users_dict?.[curr_user_email]?.AccountType === 'WF5 Administrator' ?? false;

    // if logined user is Admin then show all data (no need of filter) else show only default element (filter the data)
    if(!isCfAdmin){
      let newcfDetails = cfDetails.filter(item => item.PassCode === 0 );

      // sort the element based on CF_ID in assending order
      newcfDetails = newcfDetails.sort((a, b) => a.CF_ID - b.CF_ID);
      setCfDetails(newcfDetails);
    }
    else {
      // sort the element based on CF_ID in assending order
      const newcfDetails = cfDetails.sort((a, b) => a.CF_ID - b.CF_ID);
      setCfDetails(newcfDetails);
    }

  }, []);

  useEffect(() => {
    const unitop_output = JSON.parse(localStorage.getItem('cf-output-dict')) || {};
    if (isObjectEmpty(unitop_output) && unitop_output['cf-output'][unitopDetails.id]) {
      const cf_output = unitop_output['cf-output'][unitopDetails.id].output_user;
      const filters_no_cf = cf_output.filters_no;
      setProperties({
        ...properties,
        numberOfFilters: filters_no_cf,
        filterDP: parseFloat((cf_output.dp).toFixed(5)), // dp_cf,
        flowPerTie: parseFloat((cf_output.flow_per_t).toFixed(5)), // flow_per_tie,
        actualFlow: parseFloat((cf_output.actual_flow_per_t).toFixed(5)), // actual_flow_per_tie
      });
    }
    else {
      setProperties({
        ...properties,
        numberOfFilters: 0,
        filterDP: 0,
        flowPerTie: 0,
        actualFlow: 0
      });
    }
  }, [unitopDetails]);

  const handleChangeProperties = (event) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    const { name, value } = event.target;
    setProperties({ ...properties, [name]: value });
    disabledStripperAndExplorerTab();
    setDisableOkButton(false);
  };

  const getCFName = () => {
    let roName = '';
    const local = localStorage.getItem(unitopDetails.id);
    if (local) {
      roName = ` - ${local}`;
    } else {
      roName = ` - CF ${Number(get(unitopDetails, 'id', '').split('_')[1]) + 1}`;
    }
    return roName;
  };

  const getSelectedRowDetails = (row) => {
    for (let i = 0; i < cfDetails.length; i += 1) {
      if ((i + 1) % 2 === 0)
        $(`.cf-ag-grid-container .row_${i + 1}`).attr('class', `row_${i + 1} row-even`);
      else
        $(`.cf-ag-grid-container .row_${i + 1}`).attr('class', `row_${i + 1} row-odd`);
    }
    setSelectedRow({ ...cfDetails[row], rowIndex: row });
    if ((row + 1) % 2 === 0)
      $(`.cf-ag-grid-container .row_${row + 1}`).attr('class', `row_${row + 1} row-even row-selected`);
    else
      $(`.cf-ag-grid-container .row_${row + 1}`).attr('class', `row_${row + 1} row-odd row-selected`);
  };

  const handleOk = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    const selected = { ...selectedRow };
    const unitop_output = JSON.parse(localStorage.getItem('cf-output-dict'));
    if (isObjectEmpty(unitop_output) && unitop_output['cf-output'][unitopDetails.id]) {
      unitop_output['cf-output'][unitopDetails.id].filters_no_cf = properties.numberOfFilters;
      unitop_output['cf-output'][unitopDetails.id].dp = properties.filterDP;
      unitop_output['cf-output'][unitopDetails.id].flow_per_t = properties.flowPerTie;
      unitop_output['cf-output'][unitopDetails.id].actual_flow_per_t = properties.actualFlow;
      saveFormDataInLocalStorage({
        record: unitop_output['cf-output'][unitopDetails.id],
        type: 'cf-output',
        id: unitopDetails.id,
        item: 'cf-output-dict'
      });
    }
    saveFormDataInLocalStorage({ record: selected, type: 'cf', id: unitopDetails.id, item: 'cf-dict' });
    if ((selectedRow.rowIndex + 1) % 2 === 0)
      $(`.cf-ag-grid-container .row_${selectedRow.rowIndex + 1}`).attr('class', `row_${selectedRow.rowIndex + 1} row-even`);
    else
      $(`.cf-ag-grid-container .row_${selectedRow.rowIndex + 1}`).attr('class', `row_${selectedRow.rowIndex + 1} row-odd`);
    handleCloseCF();
    getBorderColor(unitopDetails.id);
    setokbuttonFormAutoSave(true);
  };
  return (
    <Modal
      hideBackdrop
      open={visibleCF}
      onClose={handleCloseCFModal}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="cf-modal"
    >
      <Box>
        <Rnd
          default={{
            width: '70%', height: '80%',
            x: ((window.innerWidth / 2) - ((70 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((80 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='35%'
          cancel='.cf-header-text, .field-text, .no-drag-field, .cf-ag-grid-container, .btn-combined, .no_drag'
          className='cf-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='cf-grid-container'>
            <Grid item xs={12} className='cf-header-grid'>
              <div className='cf-header-text rufusBld no_drag S_heading forground-text-primary'>Cartridge Filter {getCFName()}</div>
              <div className='cf-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleCloseCFModal}
                    style={{ width: '14px', padding: '11px' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid container style={{ padding: '15px' }}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CFProps
                  cfDetails={cfDetails}
                  handleCloseRoModal={handleCloseCFModal}
                  dbTransactionDetails={dbTransactionDetails}
                  unitopDetails={unitopDetails}
                  handleCloseCF={handleCloseCF}
                  selectedRow={selectedRow}
                  handleChangeProperties={handleChangeProperties}
                  properties={properties}
                  setIsShowErrorMessage={setIsShowErrorMessage}
                  translateObject={translateObject}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={8} lg={8} display="flex" justifyContent="space-evenly">
                <CFTable
                  cfDetails={cfDetails}
                  handleCloseRoModal={handleCloseCFModal}
                  dbTransactionDetails={dbTransactionDetails}
                  unitopDetails={unitopDetails}
                  handleCloseCF={handleCloseCF}
                  setDisableOkButton={setDisableOkButton}
                  selectedRow={selectedRow}
                  getSelectedRowDetails={getSelectedRowDetails}
                  translateObject={translateObject}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ width: '100%', border: '1px soild #D5D3E3', bottom: '50px', position: 'absolute' }} />
              <div className="btn-combined">
                <Button variant="contained" size='small' className="Secondary-Default_button minWIdth"
                  onClick={handleCloseCF}>{translateObject('Cancel')}</Button>
                <Button variant="outlined" size='small' className="Primary_Default_Button minWIdth" disabled={disableOkbutton}
                  onClick={handleOk}>{translateObject('OK')}</Button>
              </div>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default RoInput;